import React from "react";
import { observer } from "mobx-react-lite";
import { FormFieldLine } from "../../../../../components/form-field-line/form-field-line";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import { Textarea, TEXTAREA_VARIANTS } from "../../../../../components/inputs/textarea/textarea";
import { MerchantIdsValidationError } from "../../stores/migrate-global-e-merchants-page-store";
import { IValidationGroup } from "../../../../../hooks/validation-group/validation-group-hook";
import migrateGlobalEMerchantsPageStore from "../../stores/migrate-global-e-merchants-page-store";

interface IMigrateGlobalEMerchantsFormMerchantIdsInputProps {
    validationGroup: IValidationGroup;
}

const MigrateGlobalEMerchantsIdsInput: React.FC<IMigrateGlobalEMerchantsFormMerchantIdsInputProps> = observer(({
    validationGroup,
}) => {
    const parsedMerchantIdsCount = migrateGlobalEMerchantsPageStore.getParsedMerchantIds().length;
    const merchantIdsValidationError = migrateGlobalEMerchantsPageStore.getMerchantIdsValidationError();
    const enteredMerchantIdsCount = migrateGlobalEMerchantsPageStore.getMerchantIdsCount();

    return (
        <FormFieldLine
            label="Global-e Merchant IDs"
            note={
                <>
                    Paste up to 100 numeric IDs separated by <b>;</b> (e.g. <b>123456;342342;564515</b>).
                </>
            }
        >
            <div>
                <Textarea
                    value={migrateGlobalEMerchantsPageStore.getMerchantIdsRaw()}
                    onChange={migrateGlobalEMerchantsPageStore.setMerchantIds}
                    variant={TEXTAREA_VARIANTS.FIT_CONTENT}
                    validationGroup={validationGroup}
                    validationCallback={() => ({
                        isValid: merchantIdsValidationError === null,
                        messages: [],
                    })}
                />

                {merchantIdsValidationError === MerchantIdsValidationError.TOO_MANY && (
                    <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                        Too many IDs. You entered {enteredMerchantIdsCount}. Maximum allowed is 100.
                    </FontBody2>
                )}

                {merchantIdsValidationError === MerchantIdsValidationError.INVALID_FORMAT && (
                    <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                        Invalid format. Use numbers only, separated by semicolons (;).
                    </FontBody2>
                )}
                
                {merchantIdsValidationError === null && parsedMerchantIdsCount > 0 && (
                    <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                        Parsed IDs: {parsedMerchantIdsCount}
                    </FontBody2>
                )}
            </div>
        </FormFieldLine>
    );
});

export default MigrateGlobalEMerchantsIdsInput;
